import React from 'react'
import { makeStyles } from '@material-ui/styles'
import {
    InputBase
} from '@material-ui/core'
import { ColorPaper } from '../Atoms'

const useStyles = makeStyles(theme => ({
    input: {
        marginLeft: theme.spacing(0.5),
        flex: 1,
        width: "100%",
    },
    paper: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
}))
const Input = ({ value, handleChange, rightIcon = null, ...props }) => {

    const classes = useStyles()

    return (
        <ColorPaper style={{ padding: 0 }} {...props} className={classes.paper}>
            <InputBase className={classes.input} value={value} onChange={handleChange} />
            {rightIcon}
        </ColorPaper>
    )
}

export default Input